class FundingObligationBulkImportModalController {
  constructor($uibModalInstance, $timeout, downloadTemplate) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.$timeout = $timeout;
    this.downloadTemplateFn = downloadTemplate;
    this.selectedFile = null;
    this.selectedFileName = '';
    this.fileError = '';
    this.importing = false;
  }

  downloadTemplate($event) {
    if ($event) {
      $event.preventDefault();
    }
    if (typeof this.downloadTemplateFn === 'function') {
      this.downloadTemplateFn();
    }
  }

  onFileSelected(input) {
    const file = input && input.files && input.files[0];
    this.$timeout(() => {
      this.fileError = '';
      if (!file) {
        this.selectedFile = null;
        this.selectedFileName = '';
        return;
      }

      const name = file.name || '';
      const lower = name.toLowerCase();
      if (!lower.endsWith('.xlsx') && !lower.endsWith('.xls')) {
        this.selectedFile = null;
        this.selectedFileName = '';
        this.fileError = 'Please select an Excel file (.xlsx or .xls).';
        if (input) {
          input.value = '';
        }
        return;
      }

      this.selectedFile = file;
      this.selectedFileName = name;
    });
  }

  import() {
    if (!this.selectedFile || this.importing) {
      return;
    }
    this.importing = true;
    this.$uibModalInstance.close(this.selectedFile);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default FundingObligationBulkImportModalController;



// WEBPACK FOOTER //
// ./client/common/modals/fundingObligationBulkImportModal/fundingObligationBulkImportModal.controller.js